var annotate = require('annotate');
var is = require('annois');


module.exports = annotate('exp', "Returns Ex, where x is the argument, and E is Euler's constant, the base of the natural logarithms").
    on(is.number, Math.exp);



//////////////////
// WEBPACK FOOTER
// ./~/annomath/lib/exp.js
// module id = 751
// module chunks = 0